/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BooleanTimespanDto } from './booleanTimespanDto';
import { UserPaymentAccountRoleSimpleDto } from './userPaymentAccountRoleSimpleDto';
import { AddressDto } from './addressDto';


export interface PaymentAccountEditDto { 
    invoiceAddress?: AddressDto;
    accountName: string;
    prePayment: Array<BooleanTimespanDto>;
    currency: PaymentAccountEditDto.CurrencyEnum;
    preferredPaymentMethod?: PaymentAccountEditDto.PreferredPaymentMethodEnum;
    internalComment?: string;
    userPaymentAccountRoles?: Array<UserPaymentAccountRoleSimpleDto>;
    active: boolean;
}
export namespace PaymentAccountEditDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
    export const PreferredPaymentMethodEnum = {
        CreditCard: 'CREDIT_CARD',
        BankTransfer: 'BANK_TRANSFER'
    } as const;
    export type PreferredPaymentMethodEnum = typeof PreferredPaymentMethodEnum[keyof typeof PreferredPaymentMethodEnum];
}


